
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bpsPq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $84e8643b25524911$var$_jquery = $84e8643b25524911$var$_interopRequireDefault((parcelRequire("4kMWr")));
var $84e8643b25524911$var$_this = void 0;
function $84e8643b25524911$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $84e8643b25524911$var$init = module.exports.init = function init() {
    var debounce = function debounce(func) {
        var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
        var timer;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            clearTimeout(timer);
            timer = setTimeout(function() {
                func.apply($84e8643b25524911$var$_this, args);
            }, timeout);
        };
    };
    var processInput = function processInput(e) {
        if (e.target.value.length < 3) {
            (0, $84e8643b25524911$var$_jquery["default"])(".ctype-ce_themen_von_a_bis_z .hide").removeClass("hide");
            return;
        }
        (0, $84e8643b25524911$var$_jquery["default"])(".themen-link").each(function() {
            var $this = (0, $84e8643b25524911$var$_jquery["default"])(this);
            var text = $this.text();
            var re = new RegExp(e.target.value, "i");
            var position = text.search(re);
            if (position === -1) $this.parents("li").addClass("hide");
        });
        (0, $84e8643b25524911$var$_jquery["default"])(".ctype-ce_themen_von_a_bis_z ul").each(function() {
            var $this = (0, $84e8643b25524911$var$_jquery["default"])(this);
            var liEl = $this.find("li").length;
            var liElHi = $this.find("li.hide").length;
            if (liEl === liElHi) $this.parents(".hideable").addClass("hide");
        });
    };
    var processChange = debounce(function(e) {
        return processInput(e);
    });
    (0, $84e8643b25524911$var$_jquery["default"])(".ctype-ce_themen_von_a_bis_z .search-box input").on("keyup", processChange);
    (0, $84e8643b25524911$var$_jquery["default"])(".ctype-ce_themen_von_a_bis_z .search-box .btn").on("click", function() {
        (0, $84e8643b25524911$var$_jquery["default"])(".ctype-ce_themen_von_a_bis_z .search-box input").val("");
        (0, $84e8643b25524911$var$_jquery["default"])(".ctype-ce_themen_von_a_bis_z .hide").removeClass("hide");
    });
};

});


//# sourceMappingURL=ceThemenAZ.module.46c3d04b.js.map
